enum API_ROUTES {
  ROUTE_LOGIN = '/authentication/authenticate',
  ROUTE_REGISTER = '/authentication/register',
  ROUTE_GET_BALANCE = '/balance',
  ROUTE_GET_USER_INFORMATION = '/user',
  ROUTE_GET_LICENSES = '/license',
  ROUTE_GET_ORDER_HISTORY = '/history',
  ROUTE_DELETE_LICENSE = '/license/',
  ROUTE_ADD_LICENSE = '/license/',
  ROUTE_GET_ARTICLES = '/article/',
  ROUTE_UPDATE_USER_INFORMATION = '/user',
  ROUTE_CREATE_ORDER = '/balance/',
  ROUTE_RESET_PASSWORD = '/authentication/reset/',
  ROUTE_CHANGE_PASSWORD = '/user/password',
  ROUTE_CHANGE_ADDRESS = '/user/address',
  ROUTE_CREATE_INVOICE = '/invoice/',
  ROUTE_GET_INVOICE = '/invoice/',
  ROUTE_GET_INVOICES = '/invoice/all',
  ROUTE_UPDATE_BUSINESS_DATA = '/user/business',
}

export default API_ROUTES;
